import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import {ConfigurationService} from '../configuration.service';

/*
  Generated class for the AfsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AfsProvider {

  constructor(
    public afs: AngularFirestore,
    public afAuth: AngularFireAuth,
    private config: ConfigurationService
    ) {
  }

  private writeDoc(token, authResp, userData) {
    const devicesRef = this.afs.collection('devices');

    const docData = {
      token,
      userId: authResp.user.uid,
      app_userId:userData.user_id,
      timestamp: new Date().getTime(),
      provider: userData.provider
    };

    return devicesRef.doc(userData.provider+"-"+userData.user_id+"-"+token).set(docData);
  }

  writeTokenToDatabase(token: string, userData:any) {
    this.afAuth.signInAnonymously().then((authResp) => {
      this.writeDoc(token, authResp, userData);
    }).catch((error) => {
      console.log(error);
    });
  }

  getConfig() {
    return new Promise<void>((resolve) => {
      this.afAuth.signInAnonymously().then(() => {
          this.afs.collection('config').doc(this.config.getValue('configName').toString()).snapshotChanges()
          .subscribe({ next: (snapshots) => {
            const mergeConfig: any = {};
            this.config.getKeys().forEach((key) => {
              mergeConfig[key] = this.config.getValue(key);
            });

            if (localStorage.getItem('socketUrl')) {
              mergeConfig.socketUrl = localStorage.getItem('socketUrl');
            }

            if (localStorage.getItem('secSocketUrl')) {
              mergeConfig.secSocketUrl = localStorage.getItem('secSocketUrl');
            }

            if (localStorage.getItem('appicon')) {
              mergeConfig.appicon = localStorage.getItem('appicon');
            }

            if (localStorage.getItem('splashbg')) {
              mergeConfig.splashbg = localStorage.getItem('splashbg');
            }

            if (localStorage.getItem('hnr-token')) {
              const item: any = JSON.parse(localStorage.getItem('hnr-token'));
              if (item.provider) {

                const sn:any = snapshots.payload.data();
                const find = (sn)? sn.provider.find((el) => el.providerKey === item.provider) : null;

                if (find) {
                  localStorage.setItem('socketUrl', find.socketUrl);
                  localStorage.setItem('secSocketUrl', find.secSocketUrl);
                  localStorage.setItem('appicon', find.appicon);
                  localStorage.setItem('splashbg', find.splashbg);

                  Object.assign(mergeConfig, find);
                }
              }
            }

            Object.assign(mergeConfig, snapshots.payload.data());

            const url = URL.createObjectURL(new Blob([JSON.stringify(mergeConfig)], {
              type: 'text/plain'
            }));

            this.config.load(url).then(() => {
              resolve();
            });
          }, error: (err) => {
            alert(err);
            resolve();
          }});
      }).catch((error) => {
        alert(error)
        resolve();
        console.log('********AuthError*************');
        console.log(error);
      });
    });
  }

}
